import styled from 'styled-components';
import { InfoFill as InfoFillUi, NegativeFill, PositiveFill, WarningFill } from 'ui/icons';
import { colors } from 'ui/theme';

const InfoFill = styled(InfoFillUi)`
  /**
  For some reason InfoFill, although it looks the same size, has a different
  height/width than the others.
 */
  margin: 2px;
`;

export const StatusIcon = ({ status }: { status: string }) => {
  switch (status) {
    case 'Error':
      return <NegativeFill color={colors.negative100} />;
    case 'Info':
      return <InfoFill color={colors.info100} />;
    case 'Success':
      return <PositiveFill color={colors.positive100} />;
    case 'Warning':
      return <WarningFill color={colors.warning100} />;
    default:
      return <></>;
  }
};
